import { computed } from 'vue';

import { store } from './_store.js';

// eslint-disable-next-line max-params
export function use_salary_filter(salary_period, require_salary, salary_min, emit) {
	const is_annual = computed(() => salary_period.value !== `hr`);

	const salary_list = computed(() => {
		if (is_annual.value) {
			return store.lists.salary_annual;
		}

		return store.lists.salary_hourly;
	});

	const options = computed(() => [
		{
			label: `Any`,
			value: null,
		},
		{
			label: `Has salary`,
			value: `has_salary`,
		},
		...salary_list.value,
	]);

	const radio_value = computed({
		get: () => {
			if (require_salary.value === `yes`) {
				return `has_salary`;
			}

			return salary_min.value;
		},
		set: (value) => {
			if (value === `has_salary`) {
				require_salary.value = `yes`;
				salary_min.value = null;
				return;
			}

			require_salary.value = `no`;
			salary_min.value = value;

			if (value !== null && !salary_period.value) {
				salary_period.value = is_annual.value ? `yr` : `hr`;
			}
		},
	});

	function set_period(period) {
		if (salary_period.value === period) {
			return;
		}

		salary_period.value = period;
		salary_min.value = null;

		emit(`change`);
	}

	return {
		is_annual,
		options,
		radio_value,
		set_period,
	};
}
